import { type ReactNode } from 'react'
import {
  ClickableTable,
  ClickableTableBody,
  ClickableTableHead,
  ClickableTableHeader,
} from '@/components/Table/ClickableTable'
import type { TableSortOrder } from '@/components/Table'
import { type ColumnId } from '@/features/admin/bookkeeping/bookkeeping-manager-table-columns'

export interface BookkeepingManagerTableColumn {
  id: ColumnId
  header: string
  canSort: boolean
  sortOrder: TableSortOrder
}

export interface BookkeepingManagerTableProps {
  columns: BookkeepingManagerTableColumn[]
  onSort: (columnId: ColumnId, sortOrder: TableSortOrder) => void
  /**
   * The infinite scroll loader, rendered below the table.
   */
  loader?: ReactNode
  children?: ReactNode
}

export function BookkeepingManagerTable({
  columns,
  onSort,
  loader,
  children,
}: BookkeepingManagerTableProps) {
  return (
    <>
      <ClickableTable striped testId="bookkeeping-manager-table">
        <ClickableTableHead>
          {columns.map((col) => (
            <ClickableTableHeader
              key={col.id}
              canSort={col.canSort}
              sortOrder={col.sortOrder}
              onSort={(newSort) => onSort(col.id, newSort)}
            >
              {col.header}
            </ClickableTableHeader>
          ))}
        </ClickableTableHead>
        <ClickableTableBody>{children}</ClickableTableBody>
      </ClickableTable>
      {loader}
    </>
  )
}
